export const EMOJI_SHORTCODES = {
  computer: "💻",
  laptop: "💻",
  code_work: "💻",
  desktop: "🖥️",
  monitor: "🖥️",
  keyboard: "⌨️",
  gear: "⚙️",
  settings: "⚙️",
  process: "⚙️",
  package: "📦",
  library: "📦",
  deploy: "📦",
  bug: "🐛",
  lock: "🔒",
  security: "🔒",

  bulb: "💡",
  idea: "💡",
  tip: "💡",
  warning: "⚠️",
  attention: "⚠️",
  rocket: "🚀",
  launch: "🚀",
  release: "🚀",
  done: "✅",
  complete: "✅",
  completed: "✅",
  white_check_mark: "✅",
  error: "❌",
  blocked: "❌",
  cancelled: "❌",
  memo: "📝",
  note: "📝",
  docs: "📝",
  edit: "📝",

  chart_up: "📈",
  growth: "📈",
  metrics_up: "📈",
  chart_down: "📉",
  decline: "📉",
  calendar: "📅",
  deadline: "📅",
  schedule: "📅",
  target: "🎯",
  goal: "🎯",
  kpi: "🎯",
  money: "💰",
  budget: "💰",
  price: "💰",

  pushpin: "📌",
  pinned: "📌",
  important: "📌",
  search: "🔍",
  research: "🔍",
  link: "🔗",
  relation: "🔗",
  folder: "📂",
  structure: "📂",
  book: "📖",
  guide: "📖",
  instruction: "📖",

  not_started: "⬜",
  backlog: "⬜",
  in_progress: "⏳",
  progress: "⏳",
  paused: "⏸️",
  postponed: "⏸️",
  recurring: "🔄",
  repeat: "🔄",

  urgent: "🚨",
  asap: "🚨",
  critical: "🚨",
  fire: "🔥",
  high_priority: "🔴",
  medium_priority: "🟡",
  low_priority: "🔵",
  time: "⏰",

  work: "💻",
  dev: "🛠️",
  development: "🛠️",
  tools: "🛠️",
  phone: "📞",
  call: "📞",
  chat: "💬",
  communication: "💬",
  handshake: "🤝",
  meeting: "🤝",
  team: "👥",
  home: "🏠",
  cleaning: "🧹",
  sport: "🏃‍♂️",
  run: "🏃‍♂️",
  health: "🍏",
  study: "📚",
  learning: "📚",
  graduation: "🎓",

  tada: "🎉",
  smile: "😄",
  slightly_smiling_face: "🙂",
  thumbs_up: "👍",
  thumbsup: "👍",
  heart: "❤️",
  star: "⭐",
  eyes: "👀",
};
